import React from 'react';
import { DividerWrapper, Line, OrText } from './index.styles';

const OrDivider = () => (
  <DividerWrapper>
    <Line />
    <OrText>or</OrText>
    <Line />
  </DividerWrapper>
);

export default OrDivider;
